import { render, staticRenderFns } from "./VendorModal.vue?vue&type=template&id=083166d7&scoped=true"
import script from "./VendorModal.vue?vue&type=script&lang=js"
export * from "./VendorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083166d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083166d7')) {
      api.createRecord('083166d7', component.options)
    } else {
      api.reload('083166d7', component.options)
    }
    module.hot.accept("./VendorModal.vue?vue&type=template&id=083166d7&scoped=true", function () {
      api.rerender('083166d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/VendorModal.vue"
export default component.exports